import UnassignEmployeeFromPortfolioModal from "./UnassignEmployeeFromPortfolioModalContainer";

export default UnassignEmployeeFromPortfolioModal;
